/* @flow weak */
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import UserActions from 'user/UserActions';
import DialogContent from 'components/DialogContent';
import PropTypes from 'prop-types';
import * as React from 'react';

class DeleteAccountPage extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    params: PropTypes.object.isRequired,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  state = {
    disabled: true,
    error: false,
    concluded: false,
  };

  componentDidMount() {
    const onSuccess = deletionPreview => {
      this.setState({
        disabled: false,
        deletionPreview,
      });
    };

    const onError = ({ error }) => this.setState({ error });

    UserActions.verifyDeleteToken(this.props.params.token).then(onSuccess, onError);
  }

  handleCancelClick = () => {
    this.context.router.push('/landing');
  };

  handleDeleteClick = () => {
    this.setState({
      disabled: true,
    });

    const token = this.props.params.token;
    UserActions.delete(token).then(
      () => {
        this.setState({
          concluded: true,
        });
      },
      response => {
        this.setState({
          concluded: true,
          deletionError: response.error,
        });
      }
    );
  };

  renderConclusion = () => {
    let dialogProps = {
      title: 'Your account was deleted.',
      glyph: 'check',
      color: 'shamrock',
    };

    if (this.state.deletionError) {
      dialogProps = {
        title: this.state.deletionError,
        glyph: 'caution',
        color: 'lava',
      };
    }
    return <DialogContent size="xsmall" {...dialogProps} />;
  };

  renderConfirmation = () => {
    let title;
    let subtext;
    if (this.state.deletionPreview) {
      // Maybe in the future put another message for when the account is already deleted
      title =
        'Are you sure you want to delete the account at ' + this.state.deletionPreview.email + '?';
      subtext = "You will no longer have access to your classes. This action can't be undone.";
    } else {
      title = this.state.error;
      subtext = null;
    }

    return (
      <DialogContent
        size="xsmall"
        title={title}
        subtext={subtext}
        glyph="caution"
        glyphColor="lava">
        <BoxBody>
          <Button onClick={this.handleDeleteClick} disabled={this.state.disabled} level="primary">
            {'Delete'}
          </Button>
          <Button onClick={this.handleCancelClick} inline level="secondary">
            {'Cancel'}
          </Button>
        </BoxBody>
      </DialogContent>
    );
  };

  render() {
    if (this.state.concluded) {
      return this.renderConclusion();
    } else {
      return this.renderConfirmation();
    }
  }
}

export default DeleteAccountPage;
